import { useEffect } from 'react';
// @ts-expect-error: non-ts file
import { provideHooks } from 'redial';
import loadable from 'sku/@loadable/component';

import PageLoader from 'src/components/PageLoader/PageLoader';
import useAuthenticated from 'src/hooks/useAuthenticated';
import { useHasRecsQueryString } from 'src/hooks/useHasRecsQueryString';
import { useAuthLinkWithReturnUrl } from 'src/hooks/useReturnUrl';
import { getRecentSearches } from 'src/store/recentSearches';
import { expandSearchFilters } from 'src/store/search';
import type { RedialLocals } from 'src/types/RedialLocals';

import { useHomeTracking } from './useHomeTracking';

export const HomePage = loadable(
  /* #__LOADABLE__ */ () =>
    import(
      /* webpackChunkName: "HomePage" */ 'src/components/HomePage/HomePage'
    ),
);

const hooks = {
  fetch: ({ routeEnter, dispatch, cookies, country }: RedialLocals) => {
    dispatch(expandSearchFilters(false));
    return routeEnter
      ? dispatch(getRecentSearches({ cookies, country }))
      : null;
  },
};

const Home = () => {
  const hasRecsQueryString = useHasRecsQueryString();
  const signInLink = useAuthLinkWithReturnUrl({ mode: 'signin' });
  const authStatus = useAuthenticated();

  useEffect(() => {
    if (hasRecsQueryString && authStatus === 'unauthenticated') {
      window.location.href = signInLink;
    }
  }, [hasRecsQueryString, authStatus, signInLink]);

  useHomeTracking();

  return hasRecsQueryString && authStatus !== 'authenticated' ? (
    <PageLoader />
  ) : (
    <HomePage />
  );
};

export default provideHooks(hooks)(Home);
